import { Grid } from '@mui/material'
import React, { ReactNode } from 'react'

export function DataDisplayLeftRight({
    left,
    right,
}: {
    left: string | ReactNode
    right: string | ReactNode
}): JSX.Element {
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Grid item>{left}</Grid>
            <Grid item>{right}</Grid>
        </Grid>
    )
}
